var _path, _circle, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23,11.6v3.7c0,0.4-0.3,0.7-0.7,0.7H1.7c-0.4,0-0.7-0.4-0.7-0.7v-2.6L1.1,11l0.3-3.8C1.4,6.5,1.9,6,2.6,6 h15.3c0.7,0,1.3,0.4,1.6,0.9l1.8,3.2l1.1,0.6c0.1,0,0.1,0.1,0.2,0.1c0,0,0.1,0.1,0.2,0.2C22.9,11.1,23,11.3,23,11.6z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M3.3,6.9C3,6.9,2.8,7.1,2.8,7.3v0.4v1.4V10h4V9.2V7.8V6.9H3.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M14.8,10h5.3c0.2,0,0.3-0.2,0.2-0.4L18.6,7c0-0.1-0.1-0.1-0.2-0.1h-3.6c-0.1,0-0.3,0.1-0.3,0.3v2.7 C14.5,10,14.6,10,14.8,10z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000"
    },
    points: "8,6.9 8,8.1 8,8.9 8,10 13.6,10 13.6,8.9 13.6,8.1 13.6,6.9  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#000"
    },
    cx: 18.5,
    cy: 16.1,
    rx: 1.9,
    ry: 1.9
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 16.1,
    r: 1.2
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000"
    },
    cx: 18.5,
    cy: 16.1,
    r: 0.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000"
    },
    cx: 5.5,
    cy: 16.1,
    r: 1.9
  }), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 16.1,
    r: 1.2
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000"
    },
    cx: 5.5,
    cy: 16.1,
    r: 0.7
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M23,11.6v1.8h-0.5c-0.5,0-0.8-0.4-0.8-0.8v-1.4c0-0.1,0.1-0.2,0.2-0.2h0.9C22.9,11.1,23,11.3,23,11.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M2.1,11.9v0.2c0,0.3-0.1,0.5-0.3,0.7s-0.4,0.3-0.7,0.3c0,0-0.1,0-0.1,0v-0.6L1.1,11h0 C1.7,11,2.1,11.4,2.1,11.9z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 17.3,
    y: 11,
    style: {
      fill: "#000"
    },
    width: 1.4,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 11,
    style: {
      fill: "#000"
    },
    width: 1.4,
    height: 0.4
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVan);
export default __webpack_public_path__ + "static/media/van.42a5456423cd4fc665dab8f8ded51134.svg";
export { ForwardRef as ReactComponent };